// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "tradeah-7a825.firebaseapp.com",
  projectId: "tradeah-7a825",
  storageBucket: "tradeah-7a825.appspot.com",
  messagingSenderId: "632345048550",
  appId: "1:632345048550:web:6da30c3ac1f08bec689227",
  measurementId: "G-656HJQ2297"
};

// Initialize Firebase
initializeApp(firebaseConfig);
export const db = getFirestore()
